// 引入api
import { fun_PostAction } from "@/api";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      // loading状态
      loading: false,
      // 专家评审项目表主键
      expertReviewProjectId: null,
      // 标书文件制作表主键
      tenderMakeId: null,
      // 流程节点编号
      processNodeId: null,
      // 组长标志
      leaderFlag: null,
      // 分组标志
      expertGroup: null,
      // 任务编号
      taskId: null,
      expertList: null
    };
  },

  // 模板编译完成
  mounted() {
    // 标书文件制作表主键
    this.tenderMakeId = this.$route.query.tenderMakeId;
    // 专家评审项目表主键
    this.expertReviewProjectId = this.$route.query.expertReviewProjectId;
    // 获取项目信息
    this.fun_GetExpertGroup();
  },
  // 自定义方法
  methods: {
    /**
     * 获取分组标志
     * @author shuhua
     */
    fun_GetExpertGroup() {
      // 请求
      fun_PostAction("/expertGroup/init", {
        tenderMakeId: this.tenderMakeId,
        expertReviewProjectId: this.expertReviewProjectId
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 分组标志
          this.expertGroup = data.expertGroup;
          // 分组标志为1
          if (this.expertGroup === "1") {
            // 动态表头
            this.expertList = data.list;
            // 获取列表
            this.fun_GetList();
          }
        } else {
          // 操作失败
          this.$message.error(msg);
        }
      });
    },
    /**
     * 专家分组一览
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求，获取结果集
      fun_PostAction("/expertGroup/expertGroupList", {
        ...this.reqPageData,
        expertReviewProjectId: this.expertReviewProjectId
      }).then(res => {
        // 解构res.data
        const { result, msg, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取已上传标书单位
          this.tableData = data.records;
          // 分页总条数
          this.total = data.total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
      });
      // 关闭loading
      this.loading = false;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    }
  }
};
